import { render, staticRenderFns } from "./editCourtsPrice.vue?vue&type=template&id=4be1df92&scoped=true"
import script from "./editCourtsPrice.vue?vue&type=script&lang=js"
export * from "./editCourtsPrice.vue?vue&type=script&lang=js"
import style0 from "./editCourtsPrice.vue?vue&type=style&index=0&id=4be1df92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be1df92",
  null
  
)

export default component.exports